import { QueryClient } from '@tanstack/react-query';
import { HttpRequestError } from '@digiwedge/teetime-api-client';

/**
 * Status-aware retry: no retry for auth/client errors; limited retry for network/5xx.
 */
export const shouldRetry = (failureCount: number, error: unknown): boolean => {
  if (error instanceof HttpRequestError) {
    if (error.status === 401 || error.status === 403 || error.status === 404) return false;
    if (error.status === 429 || error.status >= 500) return failureCount < 2;
    if (error.status >= 400) return false;
  }
  // Network errors (fetch failed, timeout) — retry up to 3x
  return failureCount < 3;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetry,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
